// extracted by mini-css-extract-plugin
export default {"brands":"styles_brands__IHUWf","brandsContent":"styles_brandsContent__9awa-","logos":"styles_logos__Ak34V"};